import React from 'react'
import {GoogleMap, LoadScript, Marker, Polyline} from '@react-google-maps/api';
import {ICoord, IDark, IPackets} from "./I";
type MapTypeStyle = google.maps.MapTypeStyle;

const containerStyle = {
  width: '100%',
  height: '50vh'
};


const darkStyles: MapTypeStyle[] = [
  { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }]
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#263c3f" }]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#6b9a76" }]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#38414e" }]
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#212a37" }]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9ca5b3" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#746855" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#1f2835" }]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#f3d19c" }]
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#2f3948" }]
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#17263c" }]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#515c6d" }]
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#17263c" }]
  }
];

function MyMap({dark, coord, packets}: IDark & ICoord & IPackets) {
  /*
  const [map, setMap] = React.useState(null as (google.maps.Map | null))

  const onLoad = React.useCallback(function callback(map: google.maps.Map) {
    setMap(map);
  }, [])

  // noinspection JSUnusedLocalSymbols
  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])
   */

  // See https://react-google-maps-api-docs.netlify.app/#marker
  return <LoadScript googleMapsApiKey="AIzaSyDEqIarZUPa9f26FvgSZnxWd6z-bgaYqY8">
      <GoogleMap
        options={{styles: dark ? darkStyles : []}}
        mapContainerStyle={containerStyle}
        center={coord}
        zoom={9}
        /*onLoad={onLoad}
        onUnmount={onUnmount}*/>
        <Marker position={coord}>
        </Marker>
        <Polyline
          path={packets.map(({data: {Latitude,Longitude}}) =>
            ({ lat: Latitude, lng: Longitude }))}
          options={{strokeOpacity: 0.2}}
        />
      </GoogleMap>
    </LoadScript>;
}

export default React.memo(MyMap)
